import { trackAnalyticsEvent } from '@cof/refi-web-sdk';

function feedbackEvent(experimentName, feedback) {
  return new CustomEvent('host-app-event', {
    bubbles: true,
    composed: true,
    detail: {
      actionName: 'experiment-feedback',
      data: {
        experimentName,
        feedback,
      },
    },
  });
}

export const REFI_ESIGN_CONST = {
  get API_PREFIX() {
    if (REFI_ESIGN_CONST.isLocalEnv) {
      return '';
    }
    if (REFI_ESIGN_CONST.isProdEnv) {
      return 'https://api.capitalone.com';
    }
    return 'https://api-it.capitalone.com';
  },
  ESIGN_BFF_URL: '/protected/942605/applications',
  HOST_BFF_URL: '/protected/831647/host-app/bff',
  GET_FEATURE_TOGGLE_URL: featureKey => `/protected/942605/features/${featureKey}`,
  AUTOMATED_FUNDING_STATUS_URL: encodedEAppId => `/protected/942605/applications/${encodedEAppId}/automated-funding-status`,
  ASSETS_URL: `${new URL(import.meta.url)?.origin}/assets`,
  HTTP_HEADERS: {
    Accept: 'application/json;v=1',
    'Content-Type': 'application/json;v=1',
    Cookie: '',
  },
  C1_REFI_APPIDS: 'C1-REFI-APPIDS',
  REFI_CUSTOMER_EXPERIENCE_KEY: 'customer-experience',
  REFI_SESSION_KEY: 'auto-refi-session',
  REFI_SESSION_KEY_V2: 'refi-app-store',
  REFI_PI_KEY: 'auto-refi-pi',
  MARKETING_ATTRIBUTE_COOKIE: 'afw3', // set in persist-marketing-attributes
  CONTRACT_FILES_READY_EVENT: new CustomEvent('contract-files-ready', { bubbles: true, composed: true }),
  VALID_ID_ANSWERS_EVENT: new CustomEvent('verified-id'),
  NEXT_MFE_EVENT: new CustomEvent('host-app-event', {
    bubbles: true,
    composed: true,
    detail: {
      actionName: 'next-mfe',
      data: {
        currentMfe: 'esign',
      },
    },
  }),
  ROUTE_CHANGE: 'mfe-internal-route-change',
  ROUTE_CHANGE_EVENT: new CustomEvent('mfe-internal-route-change'),
  TRACK_EVENT: trackAnalyticsEvent,
  API_ERR_MSG: 'Our system experienced an error. Please try again later. For help right now, you can call us at 1-888-263-4582.',
  CUSTOMER_EXPERIENCES: {
    ICONIC_CONTRACT: 'ICONIC_CONTRACT',
  },
  PUBLIC_KEY_PRODUCT_ID: 'refiSpringbootKeys',
  HIGHLINE: {
    URL_PREFIX: () => '',
  },
  get isLocalEnv() {
    return window.location.hostname === 'localhost';
  },
  get isDevEnv() {
    return ['auto-refi-dev.clouddqt.capitalone.com', 'coaf-esign-mfe-dev.capitalone.com'].includes(window.location.hostname);
  },
  get isQAEnv() {
    return ['autorefi-ext-preprod.capitalone.com', 'coaf-esign-mfe-qa.capitalone.com'].includes(window.location.hostname);
  },
  get isProdEnv() {
    return ['autorefi.capitalone.com', 'coaf-refi-web-ui.capitalone.com', 'coaf-esign-mfe.capitalone.com'].includes(window.location.hostname);
  },
  EXP_FEEDBACK_EVENT: feedbackEvent,
  EXP_INIT_EVENT: experimentName => feedbackEvent(experimentName, { feedbackEvent: 'Initialized' }),
  EXP_SUCCESS_EVENT: (experimentName, rewardValue = 1) =>
    feedbackEvent(experimentName, {
      feedbackEvent: 'Success',
      rewardValue,
    }),
};
